// src/components/intake/IntakeGate.js
//
// Ticket 061. The email-code step. Wraps the shared OtpAuth with onSuccess and
// submitLabel ONLY; never beforeSend (SignInModal's beforeSend blocks new
// accounts, and the intake must allow them). OtpAuth never navigates.

import React from 'react'
import OtpAuth from '../OtpAuth'

export default function IntakeGate({ title, body, submitLabel, onSuccess }) {
  return (
    <div>
      <h1 className="triage-question">{title}</h1>
      <p className="triage-hint">{body}</p>
      <OtpAuth submitLabel={submitLabel} onSuccess={onSuccess} />
    </div>
  )
}
